export var AccountCurrency;
(function (AccountCurrency) {
    AccountCurrency["EUR"] = "EUR";
    AccountCurrency["USD"] = "USD";
})(AccountCurrency || (AccountCurrency = {}));
